"use client";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../card";
import { Button } from "../button";
import {
  Calendar,
  Clock,
  Users,
  Settings,
  ExternalLink,
  BookOpen,
} from "lucide-react";
import Link from "next/link";
import BookAnyMeeting from "./BookAnyMeeting";

const navigationCards = [
  {
    title: "Unified Calendar",
    description: "View all your calendar events in one place",
    icon: Calendar,
    href: "/unifiedtime/unified",
    color: "bg-calendar-unified",
  },
  {
    title: "Google Calendar",
    description: "Connect and manage your Google Calendar",
    icon: ExternalLink,
    href: "/unifiedtime/google",
    color: "bg-calendar-google",
  },
  {
    title: "Microsoft Calendar",
    description: "Connect and manage your Microsoft Calendar",
    icon: ExternalLink,
    href: "/crm/calendar/microsoft",
    color: "bg-calendar-microsoft",
  },
  {
    title: "External Events",
    description: "View events from external sources",
    icon: Clock,
    href: "/unifiedtime/external",
    color: "bg-calendar-external",
  },
  {
    title: "Book Meetings",
    description: "Schedule and manage meetings",
    icon: BookOpen,
    href: "/unifiedtime/book",
    color: "bg-primary",
  },
  {
    title: "Public Booking",
    description: "Book meetings without logging in",
    icon: BookOpen,
    href: "/unifiedtime/public-booking",
    color: "bg-green-600",
  },
  {
    title: "Setup & Settings",
    description: "Configure your calendar integrations",
    icon: Settings,
    href: "/unifiedtime/setup",
    color: "bg-secondary",
  },
];

interface CalendarHomePageProps {
  basePath?: string;
  showFeatureFlags?: boolean;
}

export default function CalendarHomePage({ basePath = "/unifiedtime", showFeatureFlags = true }: CalendarHomePageProps) {
  return (
    <div className="space-y-8">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold">UnifiedTime</h1>
        <p className="text-xl text-muted-foreground">
          Manage all your calendars in one unified view
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" style={{ paddingLeft: '20%', paddingRight: '20%' }}>
        {navigationCards.map((card) => {
          const IconComponent = card.icon;

          return (
            <Link key={card.href} href={`${basePath}${card.href.replace('/unifiedtime', '')}`}>
              <Card className="hover:shadow-lg transition-shadow cursor-pointer">
                <CardHeader>
                  <div className="flex items-center space-x-3">
                    <div className={`p-2 rounded-lg ${card.color} text-white`}>
                      <IconComponent size={24} />
                    </div>
                    <div>
                      <CardTitle>{card.title}</CardTitle>
                      <CardDescription>{card.description}</CardDescription>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Link>
          );
        })}
      </div>

      {/* Quick Actions */}
      <div className="mt-8" style={{ paddingLeft: '20%', paddingRight: '20%' }}>
        <h2 className="text-2xl font-bold mb-4">Quick Actions</h2>
        <div className="flex flex-wrap gap-4">
          <BookAnyMeeting
            customerName="New Customer"
            availableEmails={[
              "miclainkeffeler@westtn.consulting",
              "charlie.keffeler@westtn.consulting",
              "leanne.york@westtn.consulting",
            ]}
          />
        </div>
      </div>
    </div>
  );
}
